<template>
  <div class="status" v-b-tooltip.hover.bottomleft :title="statusText">
    <font-awesome-icon icon="dot-circle" class="auction" :class="status" />
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDotCircle } from "@fortawesome/free-solid-svg-icons";

library.add(faDotCircle);

export default {
  name: "Status",
  props: {
    status: String,
  },
  computed: {
    statusText: function() {
      switch (this.status) {
        case "on":
          return "Aceptando ofertas";
        case "almost":
          return "¡ En subasta !";
      }
      return "Subastado";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.status {
  .auction {
    position: relative;

    &.on {
      color: $green;
      background: radial-gradient($greenLight 50%, transparent 50%);
    }

    &.almost {
      color: $yellow;
      background: radial-gradient($yellowLight 50%, transparent 50%);
      animation: blinker 1s linear infinite;
    }

    &.off {
      color: $redAlt;
      background: radial-gradient($redLight 50%, transparent 50%);
    }
  }
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
